import Referrals from '@app/collections/referrals/Referrals'
import Head from 'next/head'

export default function ReferralsPage() {
  return (
    <>
      <Head>
        <title>Referrals - Coast</title>
      </Head>
      <Referrals />
    </>
  )
}
